<template>
    <div class="content" v-show="$store.state.isLogin" @keyup.enter="login">
        <div class="content-center">
            <button type="button" class="btn" @click="CloseLogin">
                <i class="el-icon-close"></i>
            </button>
            <div class="select-user">
                <el-radio v-model="radio" label="1" @change="use1">普通用户</el-radio>
                <el-radio v-model="radio" label="2" @change="use2" >管理员</el-radio>
            </div>
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm"
                     label-position="top">
                <el-form-item label="账号" prop="username">
                    <el-input type="text" v-model="ruleForm.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="identifycode">
                    <el-input v-model="ruleForm.identifycode" class="code-box" type="text">
                    </el-input>
                    <div class="code" @click="getCode">
                        <img :src="codePath" alt="验证码">
                    </div>
                </el-form-item>
                <el-button type="primary" @click="login" class="login-btn">登录</el-button>
                <div class="login-tip">没有账号？请前往17共享网 <a href="http://www.17gxw.cn/register?next=%2F"
                                                        target="_blank">注册</a></div>
            </el-form>
        </div>
    </div>
</template>

<script>
  import Auth from '@/auth/Auth'
  import Http from '@/utils/Http'

  export default {
    inject: ['reload'],
    data () {
      var validateUsername = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入账号'))
        } else {
          callback()
        }
      }
      var validatePassword = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入密码'))
        } else {
          callback()
        }
      }
      var identifyCode = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请验证码'))
        } else {
          callback()
        }
      }
      return {
        ruleForm: {
          username: null,
          password: null,
          identifycode: '',
          codekey: ''
        },
        radio: '1',
        codePath: '',
        admin: false,
        rules: {
          username: [
            {validator: validateUsername, trigger: 'blur'}
          ],
          password: [
            {validator: validatePassword, trigger: 'blur'}
          ],
          identifycode: [
            {validator: identifyCode, trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      use1 () {
        this.admin = false
      },
      use2 () {
        this.admin = true
      },
      login () {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            return false
          } else {
            Http.fetch(`/api/auth/login?isAdmin=${this.admin}`, {
                method: 'post',
                body: this.ruleForm
              }, result => {
                if (result.status === 'ok') {
                  const token = result.data.token
                  localStorage.userId = result.data.user.userId
                  Auth.setAccessToken(token)
                  Auth.setUser(result.data.user)
                  Http.fetch('/api/auth/limits', {}, result => {
                    Auth.setRoles(result.data.roles)
                    Auth.setPermissions(result.data.perms)
                    localStorage.role = result.data.roles.suadmin
                    // let next = this.$route.query.next || '/'
                    // this.$router.replace(next.replace(/__refresh__\d{13}/g, ''))
                  })
                  this.$message({
                    message: result.message,
                    type: 'success',
                    center: true
                  })
                  this.$store.commit('isShow')
                  this.reload()
                } else {
                  this.getCode()
                  this.$message.error({
                    message: result.message,
                    type: 'error',
                    center: true
                  })
                }
              }
            )
          }
        })
      },
      getCode () {
        fetch(`/api/auth/identifycode`).then(response => {
          this.ruleForm.codekey = response.headers.get('codekey')
          return response.blob()
        }).then(blob => {
          var url = URL.createObjectURL(blob)
          this.codePath = url
        })
      },
      CloseLogin () {
        this.$store.commit('isShow')
      }
    },
    mounted () {
      this.getCode()
    }
  }
</script>
<style scoped>
    .content {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 999;
        text-align: center;
    }

    .content .content-center {
        display: inline-block;
        position: relative;
        vertical-align: middle;
        background: #fff;
        border: 1px solid #fff;
        border-radius: 4px;
        margin-top: 200px;
    }

    .content-center .btn {
        position: absolute;
        border: none;
        background: #fff;
        top: 5px;
        right: 5px;
    }

    .content-center .demo-ruleForm {
        margin: 15px 40px;
    }

    .code {
        display: inline-block;
        position: absolute;
        top: 45px;
        left: 194px;
        vertical-align: top;
        margin-bottom: 20px;
        margin-left: 30px;
    }

    .el-form .el-form-item__content {
        margin-left: 0 !important;
    }

    .content-center .el-input {
        width: 330px;
    }

    .content .el-button {
        width: 335px;
    }

    .content >>> .el-form-item__label {
        float: left !important;
        padding: 0 !important;
    }

    .content .content-center .login-tip {
        margin-top: 10px;
        color: #000;
    }

    .content .content-center .code-box {
        /*width: 100px;*/
    }

    .content .content-center .login-tip a {
        color: #00cccc;
    }

    .content .content-center .select-user {
        margin-top: 40px;
    }

    .content .content-center >>> .el-form-item {
        margin-bottom: 15px !important;
    }

    a {
        cursor: pointer
    }
    .content .content-center >>>.el-button--primary {
        background-color: #00cccc;
        border-color: #00cccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue